export default "__VITE_ASSET__2c2c1d7e__"